<template>
  <date-time-picker
    v-model="myLocalValue"
    :range="isRange"
    :error="error"
    input-size="sm"
    format="YYYY-MM-DD HH:mm"
    formatted="YYYY-MM-DD HH:mm"
    :custom-shortcuts="[]"
    overlay />
</template>

<script>
  import DateTimePicker from 'vue-ctk-date-time-picker';
  import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

  export default {
    name: 'DatetimeInput',
    components: {DateTimePicker},

    props: {
      showErrors: Boolean,
      isRange: Boolean,
      value: String,
      value2: String
    },

    data() {
      const {value, value2, isRange} = this;
      return {
        myLocalValue: isRange ? {start: value, end: value2} : value
      }
    },

    computed: {
      error() {
        if (!this.showErrors) return false;
        if (!this.isRange) return !this.value;
        return !this.value || !this.value2;
      }
    },

    watch: {
      myLocalValue(value) {
        console.log(value);
        if (this.isRange) {
          const {start, end} = value;
          this.$emit('change', {value: start, value2: end});
        } else {
          this.$emit('change', {value})
        }
      }
    }
  };
</script>

<style scoped>

</style>
